import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { id: "price" }
const _hoisted_2 = { class: "grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 grid-cols-1 gap-4 mb-4" }
const _hoisted_3 = { class: "flex justify-between items-center mb-3 gap-3" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = {
  key: 0,
  class: "color-green text-sm mr-4"
}
const _hoisted_6 = {
  key: 1,
  class: "color-red text-sm mr-4"
}
const _hoisted_7 = { class: "" }
const _hoisted_8 = { class: "w-full flex items-center" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "lg:w-1/5 md:w-1/4 w-1/3 mr-2" }, [
  /*#__PURE__*/_createVNode("p", { class: "color-blue-grey-lighten-1 text-subtitle2" }, "Versi Revisi")
], -1)
const _hoisted_10 = { class: "lg:w-4/5 md:w-3/4 w-2/3" }
const _hoisted_11 = { class: "font-bold text-subtitle2" }
const _hoisted_12 = { class: "w-full flex items-center" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "lg:w-1/5 md:w-1/4 w-1/3 mr-2" }, [
  /*#__PURE__*/_createVNode("p", { class: "color-blue-grey-lighten-1 text-subtitle2" }, "Belaku Mulai")
], -1)
const _hoisted_14 = { class: "lg:w-4/5 md:w-3/4 w-2/3" }
const _hoisted_15 = { class: "font-bold text-subtitle2" }
const _hoisted_16 = { class: "w-full flex" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "lg:w-1/5 md:w-1/4 w-1/3 mr-2" }, [
  /*#__PURE__*/_createVNode("p", { class: "color-blue-grey-lighten-1 text-subtitle2" }, "Perubahan")
], -1)
const _hoisted_18 = { class: "lg:w-4/5 md:w-3/4 w-2/3" }
const _hoisted_19 = { class: "font-bold text-subtitle2 color-primary" }
const _hoisted_20 = { class: "w-full flex" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "lg:w-1/5 md:w-1/4 w-1/3 mr-2" }, [
  /*#__PURE__*/_createVNode("p", { class: "color-blue-grey-lighten-1 text-subtitle2" }, "Tipe Barang")
], -1)
const _hoisted_22 = { class: "lg:w-4/5 md:w-3/4 w-2/3" }
const _hoisted_23 = {
  key: 0,
  class: "font-bold text-subtitle2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")
  const _component_Paginator = _resolveComponent("Paginator")
  const _component_ListCopyEditDel = _resolveComponent("ListCopyEditDel")
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")
  const _component_RadioButton = _resolveComponent("RadioButton")
  const _component_PriceForm = _resolveComponent("PriceForm")
  const _component_Sidebar = _resolveComponent("Sidebar")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode(_component_Card, null, {
      title: _withCtx(() => []),
      content: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
            return (_openBlock(), _createBlock(_component_Card, {
              class: { 'card-no-shadow': true, 'background-white-darken-1': !item.IsActive },
              style: {"min-height":"unset !important"},
              key: index
            }, {
              content: _withCtx(() => [
                _createVNode("div", _hoisted_3, [
                  _createVNode("h5", {
                    class: "font-bold cursor-pointer hover-primary",
                    onClick: ($event: any) => (_ctx.redirectDetail(item.Id))
                  }, _toDisplayString(item.Code), 9, ["onClick"]),
                  _createVNode("div", _hoisted_4, [
                    (item.IsActive)
                      ? (_openBlock(), _createBlock("p", _hoisted_5, "Aktif"))
                      : (_openBlock(), _createBlock("p", _hoisted_6, "Non Aktif")),
                    (_ctx.route.meta.permission.update || _ctx.route.meta.permission.write || _ctx.route.meta.permission.delete)
                      ? (_openBlock(), _createBlock("i", {
                          key: 2,
                          class: "pi pi-ellipsis-h text-base cursor-pointer text-black",
                          "aria:haspopup": "true",
                          onClick: ($event: any) => (_ctx.showDropDown($event, item))
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_7, [
                  _createVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode("div", _hoisted_10, [
                      _createVNode("p", _hoisted_11, _toDisplayString(item.Version), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createVNode("div", _hoisted_14, [
                      _createVNode("p", _hoisted_15, _toDisplayString(_ctx.moment(item.EffectiveDate).format('DD MMM YYYY')), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createVNode("div", _hoisted_18, [
                      _createVNode("p", _hoisted_19, _toDisplayString(item.BaseCode ?? '-'), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createVNode("div", _hoisted_22, [
                      (item.GoodCategories)
                        ? (_openBlock(), _createBlock("p", _hoisted_23, _toDisplayString(item.GoodCategories.map(val => val.GoodCategoryName).join()), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              _: 2
            }, 1032, ["class"]))
          }), 128))
        ]),
        (_ctx.data.length > 0)
          ? (_openBlock(), _createBlock(_component_Paginator, {
              key: 0,
              rows: _ctx.filters.pageSize,
              totalRecords: _ctx.filters.totalRecords,
              onPage: _ctx.onPage
            }, null, 8, ["rows", "totalRecords", "onPage"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_OverlayPanel, { ref: "op" }, {
      default: _withCtx(() => [
        _createVNode(_component_ListCopyEditDel, {
          copy: _ctx.route.meta.permission.write,
          onCopy: _cache[1] || (_cache[1] = ($event: any) => (_ctx.duplicatePrice())),
          edit: _ctx.route.meta.permission.update,
          onEdit: _cache[2] || (_cache[2] = ($event: any) => (_ctx.redirectEdit(_ctx.dataEdit))),
          del: _ctx.route.meta.permission.delete,
          onDel: _cache[3] || (_cache[3] = ($event: any) => (_ctx.deleteData())),
          clone: false,
          onClone: _cache[4] || (_cache[4] = ($event: any) => (_ctx.clonePrice()))
        }, null, 8, ["copy", "edit", "del"])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_OverlayPanel, {
      ref: "sortOp",
      id: "sort_overlay_panel",
      class: "p-5"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sortingOption, (data) => {
          return (_openBlock(), _createBlock("div", {
            class: "p-field-radiobutton mb-2",
            key: data.key,
            onChange: ($event: any) => (_ctx.changeSorting(data.value))
          }, [
            _createVNode(_component_RadioButton, {
              id: data.key,
              class: "mr-2 radioScheduleBus",
              value: data.value,
              modelValue: _ctx.sortingValue,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.sortingValue = $event))
            }, null, 8, ["id", "value", "modelValue"]),
            _createVNode("label", {
              for: data.key
            }, _toDisplayString(data.name), 9, ["for"])
          ], 40, ["onChange"]))
        }), 128))
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Sidebar, {
      class: "type-bus-sidebar",
      visible: _ctx.sliderActive,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => (_ctx.sliderActive = $event)),
      showCloseIcon: false,
      position: "right"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_PriceForm, {
          dataEdit: _ctx.dataEdit,
          onCopy: _ctx.onCopy,
          onClone: _ctx.onClone,
          onReloadData: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getAllData())),
          onCloseSidebar: _ctx.closeSidebar
        }, null, 8, ["dataEdit", "onCopy", "onClone", "onCloseSidebar"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}